import React, { useState } from "react";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useSelector } from "react-redux";
import { convertStringToArray } from "../../Utils/utils";
import Viewer from "react-viewer";
import { imageUrl } from "../../constants/constants";

const IndexSVA = ({ setActiveTab }) => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const { data: photoGallerySVA = [], isLoading: photoGallerySVAIsloading } =
    useGetProtectedApiDataQuery({ url: "sva-photos", lang: languageType });
  const { data: indexData = [], isLoading: indexIsLoading } =
    useGetProtectedApiDataQuery({
      url: "status-summary/sva",
      lang: languageType,
    });

  const { getText } = useLanguageTranslation();
  const imagesArray = convertStringToArray(
    photoGallerySVA?.[0]?.field_mulitple_photo_upload,
  );

  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img) => ({
        src: imageUrl + img.file_path,
        alt: img.title,
      })),
    );
    setActiveIndex(index);
    setVisible(true);
  };

  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 ">
          <div className="d-flex justify-content-end">
            <ul className="inn_list list_cstar">
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("SVA Summary");
                  }}
                >
                  View More Details
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="index-sva counter-area">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 ">
              <div className="title-sec">
                <h2>{getText("Status Summery", "स्थिति सारांश")}</h2>
                <ul>
                  <li style={{ display: "none" }}></li>
                  {indexData.map((item, index) => (
                    <li className="wow zoomIn" key={index}>
                      <div className="counter-txt-sec">
                        <span className="text">{item.title}</span>
                        <span className="numbring-sec">
                          <span className="stat-number number">
                            {parseInt(item.field_add_number)}
                          </span>
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="title-sec">
                  <h2 className="mt-4">
                    {getText("Photo Gallery", "फ़ोटो गैलरी")}
                  </h2>
                </div>
                <div className="row">
                  {imagesArray.length === 0 ? (
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                      <p>{getText("Content Awaited", "प्रकरण प्रतीक्षित")}</p>
                    </div>
                  ) : (
                    imagesArray.map((item, index) => (
                      <div
                        key={index}
                        className="col-12 col-sm-12 col-md-4 col-lg-4 mb-4"
                      >
                        <div className="card-sec">
                          <div
                            className="img-sec photo-gallery-card"
                            onClick={() => {
                              openViewer(imagesArray, index);
                            }}
                          >
                            <img
                              alt={item.title}
                              src={imageUrl + item.file_path}
                            />
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
                <div>
                  <Viewer
                    visible={visible}
                    onClose={() => setVisible(false)}
                    onMaskClick={() => setVisible(false)}
                    images={currentImages}
                    activeIndex={activeIndex}
                    rotatable={false}
                    downloadable={true}
                    zoomable={true}
                    scalable={false}
                    drag={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndexSVA;
